<!-- MFITTで発車時刻を過ぎて変更操作をした場合 -->
<template>
  <ItemDialog ref="canNotChangeAfterDeparture" image-type="alert">
    <template #content-area>
      <p class="text-center">
        発車時刻を過ぎたため変更はできません。<br />
        変更できるのは発車前までです。
      </p>
    </template>
    <template #button-area>
      <ItemButton
        label="閉じる"
        action-type="btn-primary"
        @clicked="returnTopPage()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";

import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "DialogCanNotChangeAfterDeparture",
  setup() {
    const canNotChangeAfterDeparture = ref(null);

    const openDialog = () => {
      canNotChangeAfterDeparture.value.open();
    };

    const closeDialog = () => {
      canNotChangeAfterDeparture.value.close();
    };

    const returnTopPage = () => {
      closeDialog();
      nativeHandlerService.returnNativeAppTopPage();
    };

    return {
      canNotChangeAfterDeparture,
      openDialog,
      closeDialog,
      returnTopPage,
    };
  },
};
</script>
